var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "location-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg location",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.33,31.3c.17-.11.47-.36.63-.48l.84-.58a49.87,49.87,0,0,0,4.26-3.87c3.06-3.19,6.39-7.86,6.39-13a15.66,15.66,0,0,0-4.13-9.46A13.18,13.18,0,0,0,15.87,0,13.79,13.79,0,0,0,6.41,3.86a13.2,13.2,0,0,0-3.86,9.46c0,5.19,3.33,9.86,6.39,13.05a49.87,49.87,0,0,0,4.26,3.87c.54.39,1.08.83,1.47,1.06s1.45.7,1.45.7S17,31.49,17.33,31.3Zm3.6-6.79a36.73,36.73,0,0,1-4,3.59c-.39.28-1.06.8-1.06.8l-1.07-.8s-2.53-2.13-4-3.59c-2.93-3.07-5.6-7.06-5.6-11.19A10.81,10.81,0,0,1,8.27,5.73a11.39,11.39,0,0,1,7.6-3.07,10.79,10.79,0,0,1,7.59,3.07,10.55,10.55,0,0,1,3.06,7.59C26.52,17.45,23.86,21.44,20.93,24.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.87,8a5.33,5.33,0,1,0,5.32,5.33A5.35,5.35,0,0,0,15.87,8Zm0,8a2.66,2.66,0,1,1,2.66-2.66A2.67,2.67,0,0,1,15.87,16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c85ab2a493948d6036ef736147f149ce.svg";
export { ForwardRef as ReactComponent };